export default "__VITE_ASSET__CSQLrquB__"